import React from 'react';
import styles from './WizardGroups.module.scss';
import { SearchInput, IconButton } from 'components/common';
import { icons } from 'assets';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { UNGROUPED_SHOTS, EDITOR_GROUPS_STORE } from 'store';
import { Group } from '..';
import { WizardGroupsProps } from './types';

const WizardGroups = (props: WizardGroupsProps) => {
  const {
    [EDITOR_GROUPS_STORE]: {
      sortedGroupsFilteredBySelectedLocation: groups,
      selectedGroups,
      combineSelectedGroups,
      deleteSelectedGroups
    }
  } = props;
  const [searchText, setSearchText] = React.useState('');

  return (
    <>
      <div className={styles.optionsBar}>
        <SearchInput onChange={text => setSearchText(text.trim().toLowerCase())} />
        {/* <IconButton icon={icons.filter} /> */}
        <IconButton
          icon={icons.folder}
          title='Combine selected groups'
          disabled={selectedGroups.length < 2}
          onClick={combineSelectedGroups}
        />
        <IconButton
          icon={icons.trash}
          title='Delete selected'
          disabled={selectedGroups.length < 1}
          onClick={deleteSelectedGroups}
        />
      </div>
      <div className={styles.body}>
        {groups.map(group => {
          if (group.name === UNGROUPED_SHOTS || !group.name.toLowerCase().includes(searchText)) {
            return null;
          }
          return <Group
            key={group.name}
            {...group}
          />;
        }
        )}
      </div>
    </>
  );
};

export default inject(EDITOR_GROUPS_STORE)(observer(WizardGroups));
